import { CircularProgress, FormControl, FormControlLabel, Radio, RadioGroup, Typography, Box } from "@mui/material";
import { IPaymentType, IPaymentTypeList } from "../../types/Payment";
import { Colors } from "../../helpers/Consts";
import { UseQueryResult } from "react-query";
import { ChangeEvent } from "react";

type Props = {
  paymentTypesQuery: UseQueryResult<IPaymentTypeList>
  value: number | string
  onChange: (event: ChangeEvent<HTMLInputElement>, value: string) =>void
}

export default function SelectPaymentType({paymentTypesQuery, onChange, value}:Props) {
  const {data, isLoading, isError, isRefetching } = paymentTypesQuery

  if(isLoading || isRefetching) return (
    <Box>
      Carregando formas de pagamento...
      <CircularProgress />
    </Box>
  )

  if(isError) return (
    <Box>
      Ocorreu um erro ao tentar carregar as formas de pagamento. Por favor,
    </Box>
  )

  const paymentTypesList = data?.data ?? new Array<IPaymentType>()

  if(paymentTypesList.length < 1) return (
    <Box>
      Não foi encontrado nenhuma forma de pagamento cadastrada. Por favor,
      verifique sua conexão e/ou tente recarregar a página mais tarde.
    </Box>
  )

  return (
    <FormControl
    sx={{
      display: "flex",
      width: "100%",
      flexGrow: 1,
    }}
  >
    <RadioGroup
      name="payment_type"
      value={value}
      onChange={onChange}
    >
      {paymentTypesList.map((type: IPaymentType) => (
          <FormControlLabel
            key={type.id}
            value={type.id}
            control={<Radio size="medium" />}
            labelPlacement="start"
            label={
              <Typography
                fontSize="14px"
                fontWeight={700}
                sx={{ flexGrow: 1, }}
                color={
                  Number(value) !== type.id
                    ? Colors.baseTextColor
                    : "primary"
                }
              >
                {type.description}
              </Typography>
            }
          />
        ))}
    </RadioGroup>
  </FormControl>)
}